import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {DataTableModule} from 'angular-6-datatable';
import {AutoCompleteModule} from 'primeng/primeng';
import {ActivityLogComponent} from './cms/activity-log/activity-log.component';
import {VodPostersComponent} from './cms/vod/vod-detail-main/vod-posters/vod-posters.component';
import {ImdbComponent} from './cms/vod/vod-detail-main/vodedit/imdb/imdb.component';
import {AlertModalComponent} from './main/alert-modal/alert-modal.component';
import {ReportRequestComponent} from './cms/dealing/content/report-request/report-request.component';
import {AtlasDetailListDirective} from './utility/atlas-detail-list.directive';
import {AtlasUiButtonDirective} from './utility/atlas-ui-button.directive';

const ATLAS_UI_DIRECTIVES = [AtlasUiButtonDirective, AtlasDetailListDirective];

@NgModule({
  declarations: [VodPostersComponent, AlertModalComponent, ActivityLogComponent, ImdbComponent, ReportRequestComponent, ...ATLAS_UI_DIRECTIVES],
  exports: [VodPostersComponent, AlertModalComponent, ActivityLogComponent, ImdbComponent, ReportRequestComponent, ...ATLAS_UI_DIRECTIVES],
  imports: [CommonModule, FormsModule, DataTableModule, AutoCompleteModule, NgbPaginationModule],
})
export class SharedModule {}
